// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"34":"7347d648","150":"a9093f8c","307":"a9093f8c","980":"06302995"}[chunkId] + ".chunk.css";
};